var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 187.572,
    height: 117.522,
    viewBox: "0 0 187.572 117.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3585",
    "data-name": "Rectangle 3585",
    width: 187.572,
    height: 117.522,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3584",
    "data-name": "Rectangle 3584",
    width: 187.572,
    height: 131.579,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3581",
    "data-name": "Rectangle 3581",
    width: 0.442,
    height: 0.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3582",
    "data-name": "Rectangle 3582",
    width: 0.744,
    height: 0.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15423",
    "data-name": "Rectangle 15423",
    width: 44.192,
    height: 44.223,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5058",
    "data-name": "Group 5058",
    transform: "translate(39 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5057",
    "data-name": "Group 5057",
    transform: "translate(-39 18)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5056",
    "data-name": "Group 5056",
    transform: "translate(0 -14.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5055",
    "data-name": "Group 5055",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13052",
    "data-name": "Path 13052",
    d: "M163.328,291.36,20.937,291.5c-3.318,0-4.915-2.4-4.146-4.831L30.118,259.6c.622-.958,3.025-1.72,5.38-1.723l112.111-.091c2.354,0,4.781.756,5.436,1.712l14.3,27.115c.365,2.211-.7,4.744-4.018,4.748",
    transform: "translate(20.158 -159.923)",
    fill: "#dbd4fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13053",
    "data-name": "Path 13053",
    d: "M163.466,285.282l-142.172.142c-3.313,0-5.043-1.464-3.9-3.226l13.039-28.529c.621-.954,3.02-1.713,5.372-1.715l111.989-.091c2.351,0,4.775.752,5.429,1.7l14.018,28.482c1.207,1.759-.47,3.229-3.78,3.233",
    transform: "translate(19.883 -156.249)",
    fill: "#e0e7fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13054",
    "data-name": "Path 13054",
    d: "M171.87,272.842l-111.358.038c-2.9,0-4.627-1-3.4-2.842l10.532-16.7c.542-.84,2.639-1.509,4.695-1.511l88.217-.073c2.054,0,4.173.663,4.744,1.5l9.878,16.744c1.438,2.316-.411,2.845-3.3,2.847",
    transform: "translate(-4.726 -156.178)",
    fill: "#f3f7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13055",
    "data-name": "Path 13055",
    d: "M171.866,272.658,60.508,272.7c-2.9,0-4.627-.99-3.4-2.819l6.541-16.572c.542-.834,2.639-1.5,4.695-1.5l95.27-.079c2.055,0,4.173.658,4.744,1.49l6.816,16.609c1.438,2.3-.411,2.822-3.3,2.825",
    transform: "translate(-4.723 -156.169)",
    fill: "#cfd3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13056",
    "data-name": "Path 13056",
    d: "M169.549,251.862l-111.989.091c-2.352,0-4.752.761-5.372,1.715l-.084.129c.622-.957,3.026-1.718,5.382-1.72l112.142-.091c2.354,0,4.783.755,5.439,1.71l-.088-.128c-.653-.952-3.078-1.707-5.429-1.7",
    transform: "translate(-1.868 -156.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13057",
    "data-name": "Path 13057",
    d: "M163.172,333.43l-141.6.141c-3.3,0-5.026-1.452-3.889-3.2l-.286.44c-1.147,1.762.583,3.229,3.9,3.226l142.172-.142c3.31,0,4.987-1.473,3.78-3.232l-.3-.439c1.2,1.745-.477,3.2-3.774,3.207",
    transform: "translate(19.882 -204.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13058",
    "data-name": "Path 13058",
    d: "M199.044,320.921l-51.98.052,2.43-11.691,46.714-.045Z",
    transform: "translate(-60.778 -191.843)",
    fill: "#bdcbe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13059",
    "data-name": "Path 13059",
    d: "M199.044,336.388l-51.98.052.461-2.22,50.98-.05Z",
    transform: "translate(-60.778 -207.31)",
    fill: "#a4b2c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13060",
    "data-name": "Path 13060",
    d: "M199.238,334.392l-51.081.051.046-.223,50.98-.05Z",
    transform: "translate(-61.456 -207.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13061",
    "data-name": "Path 13061",
    d: "M200.169,309.179l-46.756.045.039-.187,46.672-.045Z",
    transform: "translate(-64.717 -191.691)",
    fill: "#adb2cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13062",
    "data-name": "Path 13062",
    d: "M176.7,271.036l-104,.1c-2.208,0-3.65-1.236-2.941-2.51l4.161-10.485a3.915,3.915,0,0,1,3.344-1.431l94.642-.082a4.108,4.108,0,0,1,3.433,1.445l4.176,10.472c.749,1.267-.624,2.491-2.815,2.493",
    transform: "translate(-12.71 -159.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13063",
    "data-name": "Path 13063",
    d: "M178.183,286.691H65.009l.052-.322H178.116Z",
    transform: "translate(-9.874 -177.656)",
    fill: "#cfd3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13064",
    "data-name": "Path 13064",
    d: "M179.405,280.39H68.911l.051-.317H179.34Z",
    transform: "translate(-12.294 -173.75)",
    fill: "#cfd3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13065",
    "data-name": "Path 13065",
    d: "M180.733,274.184H73.4l.05-.312h107.22Z",
    transform: "translate(-15.077 -169.903)",
    fill: "#cfd3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13066",
    "data-name": "Path 13066",
    d: "M180.547,268.07H75.777l.049-.308H180.484Z",
    transform: "translate(-16.554 -166.112)",
    fill: "#cfd3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13067",
    "data-name": "Path 13067",
    d: "M182.52,262.046H80.723l.049-.3H182.457Z",
    transform: "translate(-19.622 -162.378)",
    fill: "#cfd3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13068",
    "data-name": "Path 13068",
    d: "M91.929,256.708a5.542,5.542,0,0,0-1.409.186l93.779-.085a5.665,5.665,0,0,0-1.418-.183Z",
    transform: "translate(-25.7 -159.204)",
    fill: "#292d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13069",
    "data-name": "Path 13069",
    d: "M176.843,299.721l-112.932.108c-.982,0-1.619-.557-1.3-1.134l.468-.842a1.824,1.824,0,0,1,1.562-.692l111.339-.106a1.914,1.914,0,0,1,1.6.7l.5.841c.339.574-.267,1.125-1.242,1.126",
    transform: "translate(-8.335 -184.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M65.534,297.363l113.3-.108a2.459,2.459,0,0,0-.984-.2l-24.43.023-86.91.083a2.385,2.385,0,0,0-.973.2",
    transform: "translate(-10.199 -184.284)",
    fill: "#292d45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M168.474,125.47H47.428a3.832,3.832,0,0,1-3.832-3.832v-69.9A3.832,3.832,0,0,1,47.428,47.9H168.474a3.832,3.832,0,0,1,3.832,3.832v69.9a3.832,3.832,0,0,1-3.832,3.832",
    transform: "translate(3.411 -29.719)",
    fill: "#e4edfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13072",
    "data-name": "Path 13072",
    d: "M166.194,47.9H49.711A6.113,6.113,0,0,0,43.6,54.019v.14a6.114,6.114,0,0,1,6.114-6.114H166.194a6.113,6.113,0,0,1,6.114,6.114v-.14a6.113,6.113,0,0,0-6.114-6.114",
    transform: "translate(3.41 -29.719)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3573",
    "data-name": "Rectangle 3573",
    width: 126.287,
    height: 75.142,
    rx: 4,
    transform: "translate(48.218 19.397)",
    fill: "#172335"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3574",
    "data-name": "Rectangle 3574",
    width: 120.226,
    height: 63.395,
    transform: "translate(51.249 25.678)",
    fill: "#eff8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3575",
    "data-name": "Rectangle 3575",
    width: 80.413,
    height: 37.028,
    transform: "translate(58.182 31.592)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3576",
    "data-name": "Rectangle 3576",
    width: 80.413,
    height: 3.229,
    transform: "translate(58.182 79.956)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3577",
    "data-name": "Rectangle 3577",
    width: 80.413,
    height: 3.229,
    transform: "translate(58.182 72.418)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3578",
    "data-name": "Rectangle 3578",
    width: 4.188,
    height: 3.229,
    transform: "translate(146.905 79.956)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3579",
    "data-name": "Rectangle 3579",
    width: 4.188,
    height: 3.229,
    transform: "translate(154.489 79.956)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3580",
    "data-name": "Rectangle 3580",
    width: 4.188,
    height: 3.229,
    transform: "translate(162.073 79.956)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13073",
    "data-name": "Path 13073",
    d: "M249.3,58.254H234.506a.983.983,0,0,1-.98-.98V56.107a.983.983,0,0,1,.98-.98H249.3a.983.983,0,0,1,.98.98v1.167a.983.983,0,0,1-.98.98",
    transform: "translate(-114.417 -34.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13074",
    "data-name": "Path 13074",
    d: "M237.2,57.274a1.132,1.132,0,1,1-1.132-1.132,1.132,1.132,0,0,1,1.132,1.132",
    transform: "translate(-115.291 -34.829)",
    fill: "#172335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13075",
    "data-name": "Path 13075",
    d: "M237.481,58a.689.689,0,1,1-.689-.689.689.689,0,0,1,.689.689",
    transform: "translate(-116.016 -35.554)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5051",
    "data-name": "Group 5051",
    transform: "translate(120.776 22.07)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13076",
    "data-name": "Path 13076",
    d: "M238.359,58.358a.221.221,0,1,1-.221-.221.221.221,0,0,1,.221.221",
    transform: "translate(-237.918 -58.137)",
    fill: "#e4edfd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5054",
    "data-name": "Group 5054",
    transform: "translate(120.302 22.139)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5053",
    "data-name": "Group 5053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13077",
    "data-name": "Path 13077",
    d: "M237.412,58.69a.372.372,0,1,1-.372-.372.372.372,0,0,1,.372.372",
    transform: "translate(-236.668 -58.318)",
    fill: "#e4edfd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13078",
    "data-name": "Path 13078",
    d: "M79.875,0H7.984A7.983,7.983,0,0,0,0,7.984V47.226a7.983,7.983,0,0,0,7.984,7.983H69.66l11.171-.062a7.981,7.981,0,0,0,7.028-7.921l5.059-2.854,6.419-3.314s1.566-.48,1.292-1.907-1.292-1.277-1.292-1.277H87.858V7.984A7.984,7.984,0,0,0,79.875,0",
    transform: "translate(11.615 32.095)",
    fill: "#009b8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13091",
    "data-name": "Path 13091",
    d: "M329.4,40.7h-6.161l-17.994,0h-7.559a4.627,4.627,0,0,0-4.852,4.358l-.047,63.135a4.617,4.617,0,0,0,4.843,4.356l31.715,0a4.628,4.628,0,0,0,4.853-4.358l.047-63.135A4.617,4.617,0,0,0,329.4,40.7",
    transform: "translate(-157.337 -25.24)",
    fill: "#dbe2e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13092",
    "data-name": "Path 13092",
    d: "M304.511,80.182h27.177a1.538,1.538,0,0,0,1.538-1.538V72.58l1.886-1.674h-30.6a1.538,1.538,0,0,0-1.538,1.538v6.2a1.538,1.538,0,0,0,1.538,1.538",
    transform: "translate(-162.981 -41.984)",
    fill: "#e65460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13093",
    "data-name": "Path 13093",
    d: "M326.261,144.658h17.481a1.538,1.538,0,0,0,1.537-1.538v-6.064l1.886-1.674h-20.9a1.538,1.538,0,0,0-1.538,1.538v6.2a1.538,1.538,0,0,0,1.538,1.538",
    transform: "translate(-175.035 -77.718)",
    fill: "#e65460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13094",
    "data-name": "Path 13094",
    d: "M333.574,112.226H306.4a1.538,1.538,0,0,1-1.538-1.538v-6.064l-1.885-1.674h30.6a1.538,1.538,0,0,1,1.538,1.538v6.2a1.538,1.538,0,0,1-1.538,1.538",
    transform: "translate(-162.982 -59.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13095",
    "data-name": "Path 13095",
    d: "M333.574,176.666H306.4a1.538,1.538,0,0,1-1.538-1.538V169.1l-1.885-1.674h30.6a1.538,1.538,0,0,1,1.538,1.538v6.164a1.538,1.538,0,0,1-1.538,1.538",
    transform: "translate(-162.982 -95.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13096",
    "data-name": "Path 13096",
    d: "M329.69,40.631H297.461a4.61,4.61,0,0,0-4.6,4.618v4.24h41.434v-4.24a4.611,4.611,0,0,0-4.6-4.618",
    transform: "translate(-157.376 -25.206)",
    fill: "#243f5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13097",
    "data-name": "Path 13097",
    d: "M305.286,48.019a2.164,2.164,0,1,1-2.164-2.164,2.165,2.165,0,0,1,2.164,2.164",
    transform: "translate(-161.864 -28.101)",
    fill: "#eff8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3583",
    "data-name": "Rectangle 3583",
    width: 21.146,
    height: 1.844,
    transform: "translate(145.416 18.806)",
    fill: "#eff8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15424",
    "data-name": "Rectangle 15424",
    width: 71.065,
    height: 3.905,
    rx: 1.952,
    transform: "translate(20.304 46.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15425",
    "data-name": "Rectangle 15425",
    width: 71.065,
    height: 3.905,
    rx: 1.952,
    transform: "translate(20.304 58.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15426",
    "data-name": "Rectangle 15426",
    width: 44.513,
    height: 3.905,
    rx: 1.952,
    transform: "translate(20.304 70.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14107",
    "data-name": "Group 14107",
    transform: "translate(-1.017 46.77) rotate(-73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14106",
    "data-name": "Group 14106",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35072",
    "data-name": "Path 35072",
    d: "M8,1.194a4.074,4.074,0,0,0-5.762,0L.364,3.068a1.241,1.241,0,0,0,0,1.755L4.371,8.831a1.241,1.241,0,0,0,1.755,0L8,6.957A4.081,4.081,0,0,0,8,1.194",
    transform: "translate(26.86 8.158)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35073",
    "data-name": "Path 35073",
    d: "M9.913,6.826,3.453.364A1.24,1.24,0,0,0,1.7.364,5.809,5.809,0,1,0,9.913,8.58,1.241,1.241,0,0,0,9.913,6.826Z",
    transform: "translate(4.675 29.267)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35074",
    "data-name": "Path 35074",
    d: "M21.169,34.811a3.088,3.088,0,0,1-.7.082,3.042,3.042,0,0,1-2.156-.9l-2.34-2.34L.9,16.577a3.062,3.062,0,0,1,1.184-5.066l5.606-1.9,5.966-5.969A12.437,12.437,0,0,1,31.238,21.235L25.271,27.2l-1.9,5.607h0A3.047,3.047,0,0,1,21.169,34.811Z",
    transform: "translate(0 9.331)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35075",
    "data-name": "Path 35075",
    d: "M7.384,30.261a3.047,3.047,0,0,1-2.205,2,3.088,3.088,0,0,1-.7.082,3.042,3.042,0,0,1-2.156-.9L0,29.127A3.039,3.039,0,0,0,2.134,30a3.088,3.088,0,0,0,.7-.082,3.047,3.047,0,0,0,2.205-2h0l1.9-5.607,5.967-5.967a12.353,12.353,0,0,0,3.641-8.8A12.327,12.327,0,0,0,14,0a12.473,12.473,0,0,1,1.248,1.094,12.444,12.444,0,0,1,0,17.592L9.28,24.653l-1.9,5.607Z",
    transform: "translate(15.991 11.88)",
    fill: "#e0b031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35076",
    "data-name": "Path 35076",
    d: "M3.722,0A3.727,3.727,0,0,0,0,3.723a1.241,1.241,0,1,0,2.482,0,1.242,1.242,0,0,1,1.24-1.241A1.241,1.241,0,1,0,3.722,0",
    transform: "translate(7.583 5.23)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35077",
    "data-name": "Path 35077",
    d: "M8.951,0A8.962,8.962,0,0,0,0,8.953a1.241,1.241,0,1,0,2.482,0A6.477,6.477,0,0,1,8.951,2.482,1.241,1.241,0,1,0,8.951,0",
    transform: "translate(2.355 0)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35078",
    "data-name": "Path 35078",
    d: "M1.241,4.964A3.727,3.727,0,0,0,4.963,1.241a1.241,1.241,0,0,0-2.482,0,1.242,1.242,0,0,1-1.24,1.241,1.241,1.241,0,1,0,0,2.482",
    transform: "translate(34.001 31.657)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35079",
    "data-name": "Path 35079",
    d: "M8.951,0A1.241,1.241,0,0,0,7.71,1.241,6.477,6.477,0,0,1,1.241,7.712a1.241,1.241,0,1,0,0,2.482,8.962,8.962,0,0,0,8.951-8.953A1.241,1.241,0,0,0,8.951,0",
    transform: "translate(34.001 31.657)",
    fill: "#ea555f"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete-account.929885324e6d848959b235e8636a883e.svg";
export { ForwardRef as ReactComponent };